import React, { useEffect, useState } from "react";
import { Card, Spinner, ListGroup, Badge } from "react-bootstrap";

const BREVO_STATS_URL = "https://prdp-api.suport-949.workers.dev/api/brevo-stats";
const AUTH_HEADER = {
  Authorization: "Bearer unwantedtok",
};

const BrevoStats = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(BREVO_STATS_URL, { headers: AUTH_HEADER });
        if (!res.ok) throw new Error("Eroare la Brevo stats");
        const data = await res.json();
        const s = data.stats;

        const sent = (s.delivered ?? 0) + (s.hardBounced ?? 0) + (s.blocked ?? 0);
        const deliveredPct = sent > 0 ? Math.round((s.delivered / sent) * 100) : 0;
        const openedPct = sent > 0 ? Math.min(100, Math.round((s.opened / sent) * 100)) : 0;
        const hardBouncedPct = sent > 0 ? Math.round((s.hardBounced / sent) * 100) : 0;
        const blockedPct = sent > 0 ? Math.round((s.blocked / sent) * 100) : 0;

        setStats({
          sent,
          delivered: s.delivered,
          opened: s.opened,
          hardBounced: s.hardBounced,
          blocked: s.blocked,
          deliveredPct,
          openedPct,
          hardBouncedPct,
          blockedPct,
        });
      } catch (err) {
        setError("Nu s-au putut încărca statisticile de email.");
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <Card className="shadow-sm h-100">
      <Card.Body>
        <Card.Title className="mb-3">Statistici Email (Brevo – 7 zile)</Card.Title>
        {loading ? (
          <div className="text-center py-2">
            <Spinner animation="border" size="sm" /> Se încarcă...
          </div>
        ) : error ? (
          <div className="text-danger text-center">{error}</div>
        ) : stats ? (
          <ListGroup variant="flush">
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Emailuri trimise</span>
              <Badge bg="light" text="dark" pill>{stats.sent}</Badge>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Livrate (%)</span>
              <Badge bg="success" pill>{stats.deliveredPct}%</Badge>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Deschise (%)</span>
              <Badge bg="info" pill>{stats.openedPct}%</Badge>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Hard Bounce (%)</span>
              <Badge bg="warning" text="dark" pill>{stats.hardBouncedPct}%</Badge>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Blocate (%)</span>
              <Badge bg="danger" pill>{stats.blockedPct}%</Badge>
            </ListGroup.Item>
          </ListGroup>
        ) : (
          <div className="text-muted text-center">Fără date Brevo.</div>
        )}
      </Card.Body>
    </Card>
  );
};

export default BrevoStats;
